import useInterval from "../../utils/useInterval";
import {useContext, useRef} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {visitHistory} from "../../api/customer";

export default function VisitHistorySync() {
    const [state, ] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const previousVizitorUidRef = useRef<string | null>(null);

    useInterval(() => {
        if(!state.customer?.id || !state.customer?.sign || state.visitHistory.length === 0 || !window.document.hasFocus()) {
            return;
        }

        const vkey = JSON.stringify(state.visitHistory);

        if(vkey === previousVizitorUidRef.current ){
            // console.log('Skip visit history sync');
            return;
        }


        previousVizitorUidRef.current = JSON.stringify(state.visitHistory);

        visitHistory(state.customer.id, state.customer.sign, state.visitHistory);
    }, 5000);

    return (<></>)
}